import { createAction } from '@reduxjs/toolkit';

export const clearFaqs = createAction('content/CLEAR_FAQS');
export const fetchFaqs = createAction('content/FETCH_FAQS');
export const setFaqs = createAction('content/SET_FAQS');
